import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import WizardLayout from './wizard-layout';
import StepHeader from './step-header';
import BtButton from '../bt-button/bt-button';

interface WizardStepProps {
  step: number;
  title: string;
  description: string;
  onNext: () => void;
  onBack?: () => void;
  canProceed: boolean;
  nextLabel?: string;
  children: ReactNode;
  footer?: ReactNode;
}

const WizardStep: FC<WizardStepProps> = ({
  step, title, description, onNext, onBack, canProceed, nextLabel, children, footer,
}) => {
  const { t } = useTranslation('newSupplier', { keyPrefix: 'wizard' });

  return (
    <WizardLayout>
      <div className="flex flex-col gap-6">
        <StepHeader title={title} stepNumber={step} description={description} />
        {children}
        <div className="flex items-center justify-between">
          {onBack ? (
            <BtButton color="white" onClick={onBack}>&larr; {t('layout.back', 'Tillbaka')}</BtButton>
          ) : <div />}
          <BtButton onClick={onNext} disabled={!canProceed}>{nextLabel || t('common.next', 'Nästa')} &rarr;</BtButton>
        </div>
        {footer}
      </div>
    </WizardLayout>
  );
};

export default WizardStep;
